function fileNameParser (fileName: string): string {
  // let sanitizedFilename = file.name.replace(/\.[^/.]+$/, '')
  let sanitizedFilename = fileName
  // remove file extension from name
  sanitizedFilename = sanitizedFilename.replace(/\.[^.]+$/, '')

  // trim the filename down to no more than 30 characters
  sanitizedFilename = sanitizedFilename.substring(0, 30)

  // eliminate all characters that are not a-z, A-Z, 0-9, _ or -
  sanitizedFilename = sanitizedFilename.replace(/[^a-zA-Z0-9._-]/g, '_')

  // remove all . from the filename
  sanitizedFilename = sanitizedFilename.replace(/\./g, '_')

  // return the filename with the webp extension
  return `${sanitizedFilename}.webp`
}

export default fileNameParser
